<script setup lang="ts">
import { closeGameUserBoxDialog, gameUserBoxGameKey, gameUserBoxVisibility, openFromSection } from '@/components/layout/GameUserBoxDialog/GametUserBoxDialog'

const { isDesktop } = tools
onUnmounted(() => {
  closeGameUserBoxDialog()
})
</script>

<template>
  <el-dialog
    v-model="gameUserBoxVisibility"
    class="p-0 bg-transparent"
    :show-close="true"
    width="min(95vw, 580px)"
    modal-class="bg-black/90"
    :top="isDesktop ? undefined : '1vh'"
    :center="isDesktop"
    @close="closeGameUserBoxDialog"
  >
    <game-user-box
      v-if="gameUserBoxGameKey"
      :game-key="gameUserBoxGameKey"
      modal-mode
      :open-from-section="openFromSection"
    />
  </el-dialog>
</template>

<style scoped lang="postcss">

</style>
